import Vue from 'vue';

//

var script = Vue.extend({
    name: 'TabItem',
    props: {
        active: {
            type: Boolean,
            required: true,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
});

export default script;
